import { apiFetch } from "#lib/api";

interface IResult {
  message: string
}

interface IBody {
  service: string;
  artist_id: string;
  reason?: string;
}

export async function fetchAddProfileLink(
  service: string,
  creatorId: string,
  linkService: string,
  linkProfileId: string,
  reason?: string
) {
  const path = `/${service}/user/${creatorId}/links/new`;
  const body: IBody = {
    service: linkService,
    artist_id: linkProfileId,
    reason,
  };

  const result = await apiFetch<IResult>(path, { method: "POST", body });

  return result;
}
